export default `---
slug: france
country: France
countryCode: FR1
continent: Europe
year: 2018
title: "France"
description: "La belle France — Paris, the countryside, and very good cheese."
thumbnail: /images/travels/FR1/france_thumb.jpg
relatedLinks: []
---
![france](/images/travels/FR1/france_thumb.jpg)

*Story coming soon — stay tuned!*

I visited France and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
